import { FC, useEffect, useState } from "react";

import clsx from "clsx";

import { Draggable } from "../../dnd/Draggable";
import { SortableItem } from "../../dnd/SortableItem";
import { VisualizationAggregateType, VisualizationValueType } from "../type";
import { AggregateButton } from "./AggregateButton";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

type DragButtonProps = {
  dragKey: string;
  type: VisualizationValueType;
  label?: string;
  aggregateType?: VisualizationAggregateType;
  width?: "fit" | "full";
  hasSelectAggregate?: boolean;
  onChangeAggregate?: (axisKey: string, aggregateType: string) => void;
};

export const DragButton: FC<DragButtonProps> = ({
  dragKey,
  type,
  label,
  aggregateType,
  width = "full",
  hasSelectAggregate,
  onChangeAggregate,
}) => {
  const { t } = useTranslation();
  const _label = label || dragKey;
  const [aggregate, setAggregate] = useState<VisualizationAggregateType>(
    aggregateType || "count"
  );

  useEffect(() => {
    setAggregate(aggregateType || "count");
  }, [aggregateType]);

  const handleSelectAggregate = (value: VisualizationAggregateType) => {
    setAggregate(value);
    onChangeAggregate?.(dragKey, value);
  };

  return (
    <SortableItem
      key={dragKey}
      id={dragKey}
      className={clsx("z-10", width === "fit" ? "w-auto" : "w-full")}
    >
      <Draggable
        key={dragKey}
        id={dragKey}
        className={clsx(
          "px-2 py-1 rounded-[4px] text-start flex gap-2 items-center cursor-grab active:cursor-grabbing active:z-20",
          width === "fit" ? "w-auto" : "w-full",
          type === "number" ? "bg-sky-300" : "bg-green-300"
        )}
      >
        <span>
          {hasSelectAggregate ? `${t(`${aggregate}`)}(${_label})` : _label}
        </span>

        {hasSelectAggregate && !isMobile && (
          <AggregateButton
            type={type}
            onChangeAggregate={handleSelectAggregate}
          />
        )}
      </Draggable>
    </SortableItem>
  );
};
